<!-- Header -->
<div class="header center sticky-autohide" [class.transparent-light]="isTransparent">
  <div class="container">
    <div class="header-logo">
      <a routerLink="/"><img class="logo-dark" src="assets/images/logo-dark.png" alt="logo-dark"></a>
			<a routerLink="/"><img class="logo-light" src="assets/images/logo-light.png" alt="logo-light"></a>
    </div>

    <!-- Menu -->
    <div class="header-menu" [ngClass]="{ 'show': isMenuOpen }">
      <ul class="nav">
        <!-- Dropdown Item -->
        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(0)">Home</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 0 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/">Creative Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-two">Startup Agency</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-three">Design Lab</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/home-four">One Page</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 0 }" (click)="toggleDropdown(0)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(1)">Pages</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 1 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/about-us">About Us</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/our-team">Our Team</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/testimonials">Testimonials</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/pricing-table">Pricing Table</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/404-page">404 Error Page</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/coming-soon">Coming Soon</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 1 }" (click)="toggleDropdown(1)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(2)">Services</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 2 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/services">Services</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 2 }" (click)="toggleDropdown(2)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(3)">Portfolio</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 3 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-one">Portfolio One</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-two">Portfolio Two</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/portfolio-three">Portfolio Three</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 3 }" (click)="toggleDropdown(3)"></a>
        </li>

        <li class="nav-item">
          <a class="nav-link" [ngClass]="{ 'd-toggle': true }" href="javascript:void(0)" (click)="toggleDropdown(4)">Blogs</a>
          <ul class="nav-dropdown" [ngClass]="{ 'show': isMenuOpen && activeDropdown === 4 }">
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-grid">Blog Grid</a></li>
            <li class="nav-dropdown-item"><a class="nav-dropdown-link" routerLink="/blog-standard">Blog Standard</a></li>
          </ul>
          <!-- Toggle Link Icon -->
          <a href="javascript:void(0)" class="nav-dropdown-toggle" [ngClass]="{ 'active': isMenuOpen && activeDropdown === 4 }" (click)="toggleDropdown(4)"></a>
        </li>

        <li class="nav-item" (click)="closeMenu()">
          <a class="nav-link" routerLink="/contact">Contact Us</a>
        </li>
      </ul>
    </div>

    <!-- Social Icons -->
    <div class="header-menu-extra">
      <ul class="list-inline-sm">
        <li><a href="/"><i class="bi bi-facebook"></i></a></li>
        <li><a href="/"><i class="bi bi-twitter-x"></i></a></li>
        <li><a href="/"><i class="bi bi-linkedin"></i></a></li>
      </ul>
    </div>

    <!-- Menu Toggle -->
    <button class="header-toggle" [class.toggle-close]="isMenuOpen" (click)="toggleMenu()">
      <span></span>
    </button>
  </div>
</div>
<!-- end Header -->